export default class SVG {
    constructor(svg) {
        this.svg = svg
    }

    transpile() {
        return {
            template: '<span> ' + this.svg + ' </span>'
        }
    }
}